import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/global';

export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export function createRequestTypes(base) {
  return [START, SUCCESS, ERROR].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

export const PREFERENCE_FETCH_START = 'BI/PREFERENCE_FETCH_START';
export const PREFERENCE_FETCH_SUCCESS = 'BI/PREFERENCE_FETCH_SUCCESS';
export const PREFERENCE_FETCH_ERROR = 'BI/PREFERENCE_FETCH_ERROR';

export const PREFERENCE_PERSIST_START = 'BI/PREFERENCE_PERSIST_START';
export const PREFERENCE_PERSIST_SUCCESS = 'BI/PREFERENCE_PERSIST_SUCCESS';
export const PREFERENCE_PERSIST_ERROR = 'BI/PREFERENCE_PERSIST_ERROR';

export const fetchPreference = makeApiActionCreatorV3(
  api.fetchPreference,
  PREFERENCE_FETCH_START,
  PREFERENCE_FETCH_SUCCESS,
  PREFERENCE_FETCH_ERROR,
);

export const persistPreference = makeApiActionCreatorV3(
  api.persistPreference,
  PREFERENCE_PERSIST_START,
  PREFERENCE_PERSIST_SUCCESS,
  PREFERENCE_PERSIST_ERROR,
);
